import axios from "axios";

import { Sentry } from "src/sentry";

const api = axios.create({
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
    if (token) {
        if (config.headers && typeof config.headers.set === 'function') {
            config.headers.set("X-CSRF-Token", token);
        } else {
            config.headers["X-CSRF-Token"] = token;
        }
    }
    return config;
});

// Report API failures to Sentry. Server errors (5xx) and network failures are
// captured as exceptions; client errors (4xx) are recorded as breadcrumbs so
// they show up as context on later errors without creating their own issues.
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        const method = error.config?.method?.toUpperCase();
        const url = error.config?.url;

        if (!error.response || status >= 500) {
            Sentry.captureException(error, {
                tags: { source: "api", http_status: status ?? "network_error" },
                extra: { method, url, status },
            });
        } else {
            Sentry.addBreadcrumb({
                category: "api",
                level: "warning",
                message: `${method} ${url} -> ${status}`,
                data: { status },
            });
        }

        return Promise.reject(error);
    }
);

export default api;
